export default __webpack_public_path__ + "static/poster-231573365b985eb2bab4ae96360a112a.png";